export default "__VITE_ASSET__BO3bfI1i__"